// store/Playlists/playlistsThunks.js
import { createAsyncThunk } from "@reduxjs/toolkit";
import apiClient from "../../api/client";
import ENDPOINTS from "../../api/endpoints";
import { showNotification } from "../Notifications/notificationsSlice";

export const fetchPlaylists = createAsyncThunk(
  "playlists/fetchPlaylists",
  async (
    { page = 1, filters = [], sortModel = [] },
    { getState, rejectWithValue }
  ) => {
    try {
      const state = getState().playlists;
      const { pageSize } = state;
      const params = new URLSearchParams();

      params.set("page", page);
      params.set("pageSize", pageSize);

      if (filters.length > 0) {
        params.set("filters", JSON.stringify(filters));
      }

      if (sortModel.length > 0) {
        const { field, sort } = sortModel[0];
        params.set("sortField", field);
        params.set("sortOrder", sort);
      }

      const response = await apiClient.get(
        `${ENDPOINTS.PLAYLIST.GET_PLAYLISTS}?${params.toString()}`
      );

      return { data: response.data, page };
    } catch (error) {
      return rejectWithValue(error.response?.data?.message || error.message);
    }
  }
);

export const fetchPlaylistCalls = createAsyncThunk(
  "playlists/fetchPlaylistCalls",
  async (
    { playlistId, page = 1, filters = [], sortModel = [] },
    { getState, rejectWithValue }
  ) => {
    try {
      const state = getState().playlists;
      const { pageSize } = state;
      const params = new URLSearchParams();

      params.set("page", page);
      params.set("pageSize", pageSize);

      if (filters.length > 0) {
        params.set("filters", JSON.stringify(filters));
      }

      if (sortModel.length > 0) {
        const { field, sort } = sortModel[0];
        params.set("sortField", field);
        params.set("sortOrder", sort);
      }

      const response = await apiClient.get(
        `${
          ENDPOINTS.PLAYLIST.GET_PLAYLIST_CALLS
        }/${playlistId}?${params.toString()}`
      );

      return { data: response.data, page };
    } catch (error) {
      return rejectWithValue(error.response?.data?.message || error.message);
    }
  }
);

export const createPlaylist = createAsyncThunk(
  "playlists/createPlaylist",
  async (playlistData, { dispatch, rejectWithValue }) => {
    try {
      const response = await apiClient.post(
        ENDPOINTS.PLAYLIST.CREATE_PLAYLIST,
        playlistData
      );
      dispatch(
        showNotification({
          message: "Playlist added successfully!",
          type: "success",
        })
      );
      return response.data;
    } catch (error) {
      dispatch(
        showNotification({
          message: "Failed to create playlist",
          type: "error",
        })
      );
      return rejectWithValue(error.response?.data?.message || error.message);
    }
  }
);

export const markPlaylistAsReviewed = createAsyncThunk(
  "playlists/markPlaylistAsReviewed",
  async (playlistId, { dispatch, rejectWithValue }) => {
    try {
      const response = await apiClient.patch(
        `${ENDPOINTS.PLAYLIST.MARK_AS_REVIEWED}/${playlistId}/mark-reviewed`
      );

      dispatch(
        showNotification({
          message: "Playlist marked as reviewed!",
          type: "success",
        })
      );

      return response.data.data;
    } catch (error) {
      console.error("Mark as reviewed failed:", error);

      dispatch(
        showNotification({
          message: "Failed to mark playlist as reviewed",
          type: "error",
        })
      );

      return rejectWithValue(error.response?.data?.message || error.message);
    }
  }
);

export const getPlaylistRecordingPlaybackUrl = createAsyncThunk(
  "playlists/getPlaylistRecordingPlaybackUrl",
  async (
    { playlistId, recordingId, format = "mp3" },
    { rejectWithValue, dispatch }
  ) => {
    try {
      const response = await apiClient.get(
        `${ENDPOINTS.PLAYLIST.GET_PLAYLIST_CALL_AUDIO}/${playlistId}/recorded-calls/${recordingId}/audio?format=${format}`,
        { responseType: "blob" }
      );
      return response.data;
    } catch (error) {
      console.log("Error fetching playback URL:", error);
      const apiMessage = error.response?.data?.message;
      const fallback = error.message;
      const message = apiMessage || fallback;

      dispatch(
        showNotification({
          message: `Playback failed: ${message}`,
          type: "error",
        })
      );

      return rejectWithValue(message);
    }
  }
);
